import { createContext, useContext, useReducer } from "react";
import { accountReducer } from "./AccountReducer" 
import { Company } from "models/Company"
import { AccountStateModel, initialAccountState } from "models/AccountState"

type Props = {
  children: React.ReactNode;
};

const AccountContext = createContext<{stateAccount: AccountStateModel}>({stateAccount: initialAccountState});

const AccountProvider = ({ children }: Props) => {

  const [stateAccount, dispatch] = useReducer(accountReducer, initialAccountState)
  
  stateAccount.setCurrentCompany = (company : Company): void => {
    dispatch({ type: "set_current_company", company: company });
  };

  stateAccount.addCompanies = (company: Company[]): void => {
    dispatch({ type: "add_companies", payload: company });
  }

  stateAccount.updateCompany = (company: Company): void => {
    dispatch({ type: "update_company", payload: company });
  }

  stateAccount.addCompany = (company: Company): void => {
    dispatch({ type: "add_company", payload: company});
  }

  stateAccount.removeCompanies = ():void => {
    dispatch({ type: "remove_companies"});
  }

  stateAccount.removeCompany = (company: Company): void => {
    dispatch({ type: "remove_company", payload: company});
  }

  stateAccount.setLoadingCompanies = (loading: boolean):void => {
    dispatch({ type: "loading_companies", loading: loading});
  }

  return (<AccountContext.Provider value={{stateAccount}}>{children}</AccountContext.Provider>);
};

export default AccountProvider;

export const AccountState = () =>{
    return useContext(AccountContext);
}
